<div class="top-bar">
  <div class="container top-bar-content">
    <div class="current-date">{{ currentDate | date: 'EEEE, d MMMM yyyy' }}</div>
    <div class="top-links">
      <a href="#">A-Z Index</a>
      <a href="#">Contact Us</a>
      <a href="#">FAQ</a>
      <a href="#">Site Map</a>
    </div>
  </div>
</div>

<header>
  <div class="container header-content">
    <div class="logo-container">
      <img src="assets/data/dhet_logo.webp"
        alt="DHET Logo" class="logo-img">
      <div>
        <div class="logo-text">Department of Higher Education and Training</div>
        <div class="logo-subtext">International Scholarships Portal
          @if (isAdmin) {
            <span> - Admin Dashboard</span>
          }
          @if (isStudent) {
            <span> - Student Dashboard</span>
          }
        </div>
      </div>
    </div>
    <button class="mobile-menu-btn" id="mobileMenuBtn" type="button"
      (click)="toggleMobileMenu()"
      [attr.aria-expanded]="mobileMenuOpen"
      aria-controls="mainNav"
      [attr.aria-label]="mobileMenuOpen ? 'Close navigation menu' : 'Open navigation menu'">
      <i class="fas" [ngClass]="mobileMenuOpen ? 'fa-times' : 'fa-bars'"></i>
    </button>

    <!-- Public logged-in state (not on dashboard) -->
    @if (isLoggedIn) {
      <div class="auth-buttons">
        <app-notifications-tray></app-notifications-tray>
        <div class="user-dropdown">
          <button class="btn btn-user" (click)="showUserMenu = !showUserMenu">
            <i class="fas fa-user-circle"></i> {{ userName }} ( {{ userRole }} )
            <i class="fas fa-chevron-down"></i>
          </button>
          @if (showUserMenu) {
            <div class="user-dropdown-menu">
              <a (click)="goToDashboard(); showUserMenu = false">
                <i class="fas fa-tachometer-alt"></i> My Dashboard
              </a>
              <a routerLink="/profile" [state]="{ redirectUnauthenticatedToLogin: true }"><i class="fas fa-user"></i> My Profile</a>
              @if (isStudent) {
                <a routerLink="/student" [queryParams]="{ section: 'applications' }"><i class="fas fa-file-alt"></i> My Applications</a>
              }
              <hr>
                <a (click)="logout(); showUserMenu = false" class="logout-link">
                  <i class="fas fa-sign-out-alt"></i> Logout
                </a>
              </div>
            }
          </div>
        </div>
      }

      <!-- Logged-out state -->
      @if (!isLoggedIn) {
        <div class="auth-buttons">
          <button class="btn btn-login" id="loginBtn" (click)="openLogin()">Login</button>
          <a routerLink="/auth/register" class="btn btn-register"
          style="color: var(--primary-blue);">Register</a>
        </div>
      }
    </div>
  </header>

  <!-- Main navigation — role-aware. `[class.open]` is toggled by the
       hamburger button on small screens; clicking anywhere in the nav (i.e. a
       navigation link) closes the drawer again. -->
  <nav id="mainNav" [class.open]="mobileMenuOpen" (click)="closeMobileMenu()">
    <div class="container">
      <!-- PUBLIC nav (not logged in, or logged in on public pages) -->
      @if (!isLoggedIn) {
        <ul class="main-nav">
          <li [class.active]="isActive(homeLink)">
            <a [routerLink]="homeLink"><i class="fas fa-home"></i> Home</a>
          </li>
          <li [class.active]="isActive('/scholarships')">
            <a routerLink="/scholarships"><i class="fas fa-graduation-cap"></i> Scholarships</a>
          </li>
          <li [class.active]="isActive('/events')">
            <a routerLink="/events"><i class="fas fa-calendar-alt"></i> Events</a>
          </li>
          <li><a href="#"><i class="fas fa-handshake"></i> Partners</a></li>
          <li [class.active]="isActive('/alumni')">
            <a routerLink="/alumni"><i class="fas fa-users"></i> Alumni</a>
          </li>
        </ul>
      }

      <!-- STUDENT dashboard nav -->
      @if (isLoggedIn && isStudent) {
        <ul class="main-nav">
          <li [class.active]="isStudentDashboardActive()">
            <a routerLink="/student" [state]="{ redirectUnauthenticatedToLogin: true }"><i class="fas fa-tachometer-alt"></i> Dashboard</a>
          </li>
          <li [class.active]="isActive('/scholarships')">
            <a routerLink="/scholarships"><i class="fas fa-graduation-cap"></i> Scholarships</a>
          </li>
          <li [class.active]="isActive('/alumni')">
            <a routerLink="/alumni"><i class="fas fa-users"></i> Alumni</a>
          </li>
          <li [class.active]="isStudentSectionActive('applications')">
            <a routerLink="/student" [queryParams]="{ section: 'applications' }" [state]="{ redirectUnauthenticatedToLogin: true }"><i class="fas fa-file-alt"></i> My Applications</a>
          </li>
          <li [class.active]="isStudentSectionActive('documents')">
            <a routerLink="/student" [queryParams]="{ section: 'documents' }" [state]="{ redirectUnauthenticatedToLogin: true }"><i class="fas fa-file-download"></i> Documents</a>
          </li>
          <li [class.active]="isStudentSectionActive('flights')">
            <a routerLink="/student" [queryParams]="{ section: 'flights' }" [state]="{ redirectUnauthenticatedToLogin: true }"><i class="fas fa-plane"></i> Flight Booking</a>
          </li>
          @if (authorization.hasPermission(permissions.EventView)) {
            <li [class.active]="isStudentSectionActive('events')">
              <a routerLink="/student" [queryParams]="{ section: 'events' }" [state]="{ redirectUnauthenticatedToLogin: true }"><i class="fas fa-calendar-check"></i> Events</a>
            </li>
          }
          <li [class.active]="isActive('/profile')">
            <a routerLink="/profile" [state]="{ redirectUnauthenticatedToLogin: true }"><i class="fas fa-user"></i> My Profile</a>
          </li>
        </ul>
      }

      <!-- ADMIN dashboard nav -->
      @if (isLoggedIn && isAdmin) {
        <ul class="main-nav">
          <li [class.active]="isAdminDashboardActive()">
            <a routerLink="/admin" [state]="{ redirectUnauthenticatedToLogin: true }"><i class="fas fa-tachometer-alt"></i> Dashboard</a>
          </li>
          <li [class.active]="isActive('/scholarships')">
            <a routerLink="/scholarships"><i class="fas fa-graduation-cap"></i> Scholarships</a>
          </li>
          @if (authorization.hasPermission(permissions.FlightRequestView)) {
            <li [class.active]="isAdminSectionActive('flights')">
              <a routerLink="/admin" [queryParams]="{ section: 'flights' }" [state]="{ redirectUnauthenticatedToLogin: true }"><i class="fas fa-plane"></i> Flight Requests</a>
            </li>
          }
          @if (authorization.hasPermission(permissions.EventManage)) {
            <li [class.active]="isAdminSectionActive('events')">
              <a routerLink="/admin" [queryParams]="{ section: 'events' }" [state]="{ redirectUnauthenticatedToLogin: true }"><i class="fas fa-calendar-plus"></i> Events</a>
            </li>
          }
          @if (authorization.hasPermission(permissions.UserManage)) {
            <li [class.active]="isAdminSectionActive('users')">
              <a routerLink="/admin" [queryParams]="{ section: 'users' }" [state]="{ redirectUnauthenticatedToLogin: true }"><i class="fas fa-users-cog"></i> Manage Users</a>
            </li>
          }
          @if (authorization.hasPermission(permissions.FinanceManage)) {
            <li [class.active]="isActive('/finance')"><a routerLink="/finance"><i class="fas fa-wallet"></i> Finance</a></li>
          }
          @if (authorization.hasPermission(permissions.UserManage)) {
            <li [class.active]="isActive('/admin?section=settings')"><a routerLink="/admin" [queryParams]="{ section: 'settings' }"><i class="fas fa-cog"></i> Settings</a></li>
          }
          <li>
            <a routerLink="/admin" [state]="{ redirectUnauthenticatedToLogin: true }"><i class="fas fa-chart-bar"></i> Reports</a>
          </li>
          <li [class.active]="isActive('/profile')">
            <a routerLink="/profile" [state]="{ redirectUnauthenticatedToLogin: true }"><i class="fas fa-user"></i> My Profile</a>
          </li>
        </ul>
      }
    </div>
  </nav>

  <!-- Breadcrumb (only on dashboard/profile pages, so it does not duplicate page breadcrumbs).
       Same shape as the other page breadcrumbs: a full-width band with an inner
       .container, so the crumb starts where the first main-menu item starts. -->
  @if (showHeaderBreadcrumb) {
    <div class="breadcrumb">
      <div class="container">
        <a [routerLink]="homeLink">Home</a> &raquo;
        @if (isProfilePage()) {
          <span>My Profile</span>
        } @else if (isAdmin) {
          <a routerLink="/admin">Admin</a> &raquo;
          @if (isAdminSectionActive('flights')) {
            <span>Flight Requests</span>
          } @else if (isAdminSectionActive('applications')) {
            <span>Review Applications</span>
          } @else if (isAdminSectionActive('users')) {
            <span>User Management</span>
          } @else {
            <span>Dashboard</span>
          }
        } @else if (isStudent) {
          <a routerLink="/student">Student</a> &raquo;
          @if (isStudentSectionActive('applications')) {
            <span>My Applications</span>
          } @else if (isStudentSectionActive('documents')) {
            <span>Documents</span>
          } @else if (isStudentSectionActive('flights') || isFlightRequestsPage()) {
            <span>Flight Booking</span>
          } @else {
            <span>Dashboard</span>
          }
        }
      </div>
    </div>
  }

  @if (showLoginModal) {
    <app-login-modal (closeModal)="closeLogin()"></app-login-modal>
  }
